<template>
    <div class="content">
         <div class="tool">
             <el-button type="primary" class="el-icon-plus" style="margin-right:20px" @click="AddClick"> 新增</el-button>
             <el-input placeholder="请输入名称" v-model="searchForm.searchInfo" style="width:200px;">
                 <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
             </el-input>
         </div>
 
         <el-table :data='DataList' border stripe :highlight-current-row='true' max-height='calc(100vh - 160px)' height='calc(100vh - 160px)'>
             <el-table-column align="center" prop="acc_type" label="账户类型">
                <template slot-scope="scope">
                    {{scope.row.acc_type===0?'个人账户':'企业账户'}}
                  </template>
             </el-table-column>
             <el-table-column align="center" prop="contractNo" label="商户编号" width="180px"></el-table-column>
             <el-table-column align="center" prop="loginNo" label="登录号"></el-table-column>
             <el-table-column align="center" prop="customerName" label="名称"></el-table-column>
             <el-table-column align="center" prop="certificateNo" label="证件号"></el-table-column>
             <el-table-column align="center" prop="mobileNo" label="联系人手机号"></el-table-column>
             <el-table-column align="center" prop="selfEmployed" label="商户类型">
                <template slot-scope="scope">
                    {{scope.row.acc_type===0?'个人':(scope.row.selfEmployed===0?'个体户':'企业')}}
                  </template>
             </el-table-column>
             <el-table-column align="center" prop="corporateName" label="法人"></el-table-column>
             <el-table-column align="center" prop="acc_status" label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.acc_status === 1 ? 'success' :(scope.row.acc_status===2?'warning':'danger')" disable-transitions>{{scope.row.acc_status===1?'开户成功':(scope.row.acc_status===2?'开户中':(scope.row.acc_status===0?'失败':'异常'))}}</el-tag>
                </template>
             </el-table-column>
             <el-table-column align="center" label="操作">
                 <template slot-scope="scope">
                     <div class="link_btn">
                         <el-link v-if="scope.row.acc_status===2" type="primary" @click="SearchResult(scope.row)">查询开户结果</el-link>
                         <el-link type="primary" @click="Edit(scope.row)">修改绑卡</el-link>
                         <el-link type="primary" @click="Transfer(scope.row)">收支明细</el-link>
                     </div>
                 </template>
             </el-table-column>
         </el-table>
         <el-pagination layout="prev, pager, next" @current-change="current_change" :total="searchForm.total" background :page-size="searchForm.pageSize"></el-pagination>


         <el-dialog :title="title" :visible.sync="dialogVisible" width='60%' :append-to-body='true'>
            <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px" size='medium'>
                <el-form-item v-if="isEditCard" label="账户类型">
                    <el-radio-group v-model="accountForm.acc_type">
                        <el-radio :label="0" >个人账户</el-radio>
                        <el-radio :label="1">企业账户</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="isEditCard" label="登录账号" prop="loginNo">
                    <el-tooltip class="item" effect="dark" content="长度要求11位以上" placement="bottom-start">
                        <el-input v-model="accountForm.loginNo"></el-input>
                    </el-tooltip>
                </el-form-item>
                <div v-if="accountForm.acc_type===0">
                    <el-form-item v-if="isEditCard" label="客户名称" prop="customerName">
                        <el-tooltip class="item" effect="dark" content="客户名称与持卡人姓名一致" placement="bottom-start">
                            <el-input v-model="accountForm.customerName"></el-input>
                        </el-tooltip>
                      </el-form-item>
                      <el-form-item v-if="isEditCard" label="身份证号" prop="certificateNo">
                        <el-input v-model="accountForm.certificateNo"></el-input>
                      </el-form-item>
                      <el-form-item label="银行卡号" prop="cardNo">
                          <el-input v-model="accountForm.cardNo"></el-input>
                      </el-form-item>
                      <el-form-item label="手机号码" prop="mobileNo">
                          <el-tooltip class="item" effect="dark" content="与银行预留手机号一致" placement="right-start">
                              <el-input v-model="accountForm.mobileNo"></el-input>
                          </el-tooltip>
                      </el-form-item>
                </div>
                <div v-if="accountForm.acc_type===1">
                    <el-form-item v-if="isEditCard" label="商户名称" prop="customerName">
                        <el-input v-model="accountForm.customerName"></el-input>
                      </el-form-item>
                    <el-form-item v-if="isEditCard" label="邮箱" prop="email">
                        <el-input v-model="accountForm.email"></el-input>
                      </el-form-item>
                      <el-form-item v-if="isEditCard" label="商户类型">
                        <el-radio-group v-model="accountForm.selfEmployed">
                            <el-radio :label="0" >个体户</el-radio>
                            <el-radio :label="1">企业</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item v-if="isEditCard" label="营业执照" prop="certificateNo">
                        <el-input v-model="accountForm.certificateNo"></el-input>
                      </el-form-item>
                      <el-form-item v-if="isEditCard" label="法人姓名" prop="corporateName">
                        <el-input v-model="accountForm.corporateName"></el-input>
                    </el-form-item>
                    <el-form-item v-if="isEditCard" label="法人证件类型">
                        <el-radio-group v-model="accountForm.corporateCertType">
                            <el-radio :label="0" >身份证</el-radio>
                            <el-radio :label="1">港澳通行证</el-radio>
                            <el-radio :label="2">台湾内地通行证</el-radio>
                            <el-radio :label="3">护照</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="isEditCard" label="证件号码" prop="corporateCertId">
                        <el-input v-model="accountForm.corporateCertId"></el-input>
                    </el-form-item>
                    <el-form-item label="法人手机号">
                        <el-tooltip class="item" effect="dark" content="当开户为个体户且绑定对私卡时必填" placement="bottom-start">
                            <el-input v-model="accountForm.corporateMobile"></el-input>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item v-if="isEditCard" label="所属行业">
                        <el-select v-model="accountForm.industryId" placeholder="请选择所属行业" style="width: 100%;">
                            <el-option label="数字娱乐" :value="9902"></el-option>
                            <el-option label="互联网金融" :value="9910"></el-option>
                            <el-option label="保险" :value="9911"></el-option>
                            <el-option label="航旅" :value="9923"></el-option>
                            <el-option label="消费金融" :value="9926"></el-option>
                            <el-option label="基金" :value="9927"></el-option>
                            <el-option label="大宗商品现货交易" :value="9928"></el-option>
                            <el-option label="收藏品交易" :value="9929"></el-option>
                            <el-option label="电商B2B" :value="9930"></el-option>
                            <el-option label="零售B2C" :value="9931"></el-option>
                            <el-option label="代理商" :value="9937"></el-option>
                            <el-option label="物流" :value="9938"></el-option>
                            <el-option label="金融租赁" :value="9940"></el-option>
                            <el-option label="票据" :value="9941"></el-option>
                            <el-option label="教育培训" :value="9943"></el-option>
                            <el-option label="公共服务及便民服务" :value="9946"></el-option>
                            <el-option label="跨境服务贸易" :value="9980"></el-option>
                            <el-option label="跨境货物贸易" :value="9981"></el-option>
                            <el-option label="货币代兑" :value="9982"></el-option>
                            <el-option label="金融机构" :value="9983"></el-option>
                            <el-option label="征信" :value="9990"></el-option>
                            <el-option label="有偿资讯" :value="10012"></el-option>
                            <el-option label="其他" :value="9999"></el-option>
                          </el-select>
                    </el-form-item>
                    <el-form-item label="联系人姓名">
                        <el-input v-model="accountForm.contactName"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人手机号">
                        <el-input v-model="accountForm.mobileNo"></el-input>
                    </el-form-item>
                    <el-form-item label="银行名称" prop="bankName"> 
                        <el-input v-model="accountForm.bankName"></el-input>
                    </el-form-item>
                    <el-form-item label="银行卡号" prop="cardNo">
                        <el-input v-model="accountForm.cardNo"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行省份" prop="depositBankProvince">
                        <el-input v-model="accountForm.depositBankProvince"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行城市" prop="depositBankCity">
                        <el-input v-model="accountForm.depositBankCity"></el-input>
                    </el-form-item>
                    <el-form-item label="支行名称" prop="depositBankName">
                        <el-input v-model="accountForm.depositBankName"></el-input>
                    </el-form-item>
                    <el-form-item v-if="isEditCard" label="持卡人姓名">
                        <el-tooltip class="item" effect="dark" content="当开个体户且绑定对私卡时需填,否则默认绑定对公卡" placement="top">
                            <el-input v-model="accountForm.cardUserName"></el-input>
                        </el-tooltip>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>


        
        <el-dialog title="收支明显" :visible.sync="detailDialogVisible" width='60%' :append-to-body='true'>
            <div>
                <div>
                    <el-date-picker v-model="detail_begintime" type="date" placeholder="起始日期"></el-date-picker>
                    <span style="margin-left: 10px;margin-right: 10px;">--</span>
                    <el-date-picker v-model="detail_endtime" type="date" placeholder="截止日期"></el-date-picker>
                    <el-button type="primary" style="margin-left: 15px;">查询</el-button>
                </div>
                <el-table :data='TransferDataList' border stripe :highlight-current-row='true' style="margin-top: 15px;">
                    <el-table-column align="center" prop="transType" label="交易类型">
                        <template slot-scope="scope">
                            {{scope.row.transType==='RECHARGE'?'入金':(scope.row.transType==='TRANSFER'?'划拨':'出金')}}
                          </template>
                    </el-table-column>
                    <el-table-column align="center" prop="drCrFlag" label="余额方向">
                        <template slot-scope="scope">
                            {{scope.row.drCrFlag==='CR'?'收入':'支出'}}
                          </template>
                    </el-table-column>
                    <el-table-column align="center" prop="amount" label="交易金额(元)"></el-table-column>
                    <el-table-column align="center" prop="afterBal" label="交易后余额(元)"></el-table-column>
                    <el-table-column align="center" prop="transSerialNo" label="商户订单号"></el-table-column>
                    <el-table-column align="center" prop="businessTadeType" label="商业类型">
                        <template slot-scope="scope">
                            {{scope.row.businessTadeType==='SHARE'?'分账':(scope.row.businessTadeType==='OFFSET_SHARE'?'差额分账':(scope.row.businessTadeType==='REFUND'?'退款':(
                                scope.row.businessTadeType==='TRANSFER'?'转账':(scope.row.businessTadeType==='WITHDRAW'?'提现':(scope.row.businessTadeType==='CLEAR'?'资金清算':(
                                    scope.row.businessTadeType==='OTHER'?'其他':'提现退回'
                                )))
                            )))}}
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination layout="prev, pager, next" @current-change="detail_current_change" :total="detailTotal" background :page-size="15"></el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>


     </div>
 </template>
 

<script>
import util from '../../util/util'


export default{
    data:function(){
        return{
            searchForm:{
                searchInfo:'',
                pageNo:1,
                pageSize:15,
                total:0,
            },
            
            DataList:[],

            isEditCard:true,

            dialogVisible:false,
            title:'',

            requestId:'',

            accountForm:{
                acc_id:0,
                acc_type:1,
                loginNo:'',
                customerName:'',
                certificateNo:'',
                cardNo:'',
                mobileNo:'',

                email:'',
                selfEmployed:1,
                corporateName:'',
                corporateCertType:0,
                corporateCertId:'',
                corporateMobile:'',
                industryId:9999,
                contactName:'',
                bankName:'',
                depositBankProvince:'',
                depositBankCity:'',
                depositBankName:'',
                cardUserName:'',

                
            },

            rules:{
                customerName:[ { required: true, message: '请输入登录账号', trigger: 'blur' }],
                loginNo:[ { required: true, message: '请输入客户名称', trigger: 'blur' }],
                certificateNo:[ { required: true, message: '请输入证件号', trigger: 'blur' }],
                cardNo:[ { required: true, message: '请输入银行卡号', trigger: 'blur' }],
                mobileNo:[ { required: true, message: '请输入手机号码', trigger: 'blur' }],

                email:[ { required: true, message: '请输入邮箱', trigger: 'blur' }],
                corporateName:[ { required: true, message: '请输入法人姓名', trigger: 'blur' }],
                corporateCertId:[ { required: true, message: '请输入证件号码', trigger: 'blur' }],
                bankName:[ { required: true, message: '请输入银行名称', trigger: 'blur' }],
                depositBankProvince:[ { required: true, message: '请输入开户行省份', trigger: 'blur' }],
                depositBankCity:[ { required: true, message: '请输入开户行城市', trigger: 'blur' }],
                depositBankName:[ { required: true, message: '请输入支行名称', trigger: 'blur' }],
            },



            detailDialogVisible:false,
            TransferDataList:[],
            detailTotal:0,
            detailPageNo:1,
            detail_begintime:'',
            detail_endtime:''
        }
    },
    created(){

    },
    mounted(){
        this.getDataList()
    },
    methods:{
        getDataList(){
            util.Get('bofooaccount/GetAccountDataList',this.searchForm).then(res=>{
                if(res.rpStatus===10000){
                    this.searchForm.total= res.total
                    this.DataList= res.list
                }
            })
        },
        Search(){
            this.getDataList()
        },
        AddClick(){
            this.title='新增账户'
            this.isEditCard=true
            this.dialogVisible=true
            this.accountForm.acc_type=1
            this.accountForm.loginNo=''
            this.accountForm.customerName=''
            this.accountForm.certificateNo=''
            this.accountForm.cardNo=''
            this.accountForm.mobileNo=''
            this.accountForm.email=''
            this.accountForm.selfEmployed=1
            this.accountForm.corporateName=''
            this.accountForm.corporateCertType=0
            this.accountForm.corporateCertId=''
            this.accountForm.corporateMobile=''
            this.accountForm.industryId=9999
            this.accountForm.contactName=''
            this.accountForm.bankName=''
            this.accountForm.depositBankProvince=''
            this.accountForm.depositBankCity=''
            this.accountForm.depositBankName=''
            this.accountForm.cardUserName=''
            
        },
        Edit(row){
            this.title='修改绑定卡'
            this.accountForm.acc_id=row.acc_id
            this.accountForm.acc_type=row.acc_type
            this.isEditCard=false
            this.dialogVisible=true
        },
        submit(){
            this.$refs.accountForm.validate((valid) =>{
                if (valid) {
                    if(!this.requestId){
                        this.requestId=util.ReturnSerialNo()
                        if(this.isEditCard){
                            util.Post('bofooaccount/createaccount?requestId='+this.requestId,this.accountForm).then(res => {
                                if (res.rpStatus === 10000) {
                                    this.getDataList()
                                    this.dialogVisible=false
                                }
                                this.requestId=''
                            })
                        }   
                        else{
                            util.Post('bofooaccount/EditBandingCard?requestId='+this.requestId,this.accountForm).then(res => {
                                if (res.rpStatus === 10000) {
                                    this.getDataList()
                                    this.dialogVisible=false
                                }
                                this.requestId=''
                            })
                        }
                    }
                }
            })
        },
        current_change(page){
            this.searchForm.pageNo=page
            this.GetDataList()
        },

        //查询开户结果
        SearchResult(row){
            if(!this.requestId){
                this.requestId=util.ReturnSerialNo()   
                util.Post('bofooaccount/queryaccountResult?requestId='+this.requestId+"&id="+row.acc_id).then(res => {
                    if(res.rpStatus===10000){
                        this.$message.success('查询账户成功')
                        this.getDataList()
                    }
                    this.requestId=''
                })
            }
        },

        //收支明细
        Transfer(row){
            this.detailDialogVisible=true
            this.getDetailDataList()
        },
        getDetailDataList(){
            if(!this.requestId){
                this.requestId=util.ReturnSerialNo()   
                util.Get('bofooaccount/BofooTransferDetail?requestId='+this.requestId+"&id="+row.acc_id+"&begintime="+this.detail_begintime+"&endtime="+this.detail_endtime+"&pageno="+this.detailPageNo).then(res => {
                    if(res.rpStatus===10000){
                        this.$message.success('查询账户成功')
                        this.getDataList()
                    }
                    this.requestId=''
                })
            }
        },
        detail_current_change(page){
            this.detailPageNo=page
            this.getDetailDataList()
        }
    }
}
</script>


<style scoped>
.content{
    display: flex;
    flex-direction: column;
    justify-content: start;
    height: 100%;
}
.tool{
    display: flex;
    flex-direction: row;
    justify-content: start;

}
.el-table{
width: 100%;
font-size:13px;
margin-top:10px;
}
.el-link{
    margin-right: 10px;
    font-size: 12px;
}
::v-deep .el-dialog{
  --el-bg-color:#000741 !important;
}
::v-deep .el-dialog__header{
  --el-text-color-primary:#1effff;
  --el-text-color-regular:#fff;
  padding: 0px !important;
  background-color: #309CE2;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .el-dialog__title{
    color: white;
}

::v-deep .el-dialog__headerbtn .el-dialog__close{
    color: white;
} 
</style>